import cropApplicationReducer from "./cropApplicationReducer";
import cropApplicationDraftReducer from "./cropApplicationDraftReducer";

const cropApplicationReducers = {
    cropApplication: cropApplicationReducer,
    cropApplicationDraft: cropApplicationDraftReducer
};

export default cropApplicationReducers;